import { CONFIG } from 'app/config/config';
import { API } from '../../config/api';
import { TextEncoder } from 'text-encoding';
import { saveAs } from 'file-saver';
import * as qs from 'qs';

var google: any;
declare var EXIF: any;
declare var $: any;

export class Deferred<T> {
    promise: Promise<T>;
    resolve: (value?: T | PromiseLike<T>) => void;
    reject: (reason?: any) => void;

    constructor() {
        this.promise = new Promise<T>((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}

export class GlobalFunction {

    static list_tier_of_activitys: any = [
        // {value: null,label: 'N/A', 'description':''},
        {value: 'joint_school_activity', label: 'Joint School Activity'         ,'description':'Group/activity involved students from different schools'},
        {value: 'school_based_activity',label: 'School-based Activity'          ,'description':'Student development activities may cover students from targeted and non-targeted forms in a school'},
        {value: 'group_learning_support',label: 'Group Learning Support'  ,'description':'In-class or out of class learning group/activity covers students from targeted forms in a school'},
        {value: 'individual_mentoring',label: 'Mentoring'            ,'description':'Activity facilitates establishment of supportive relationship between mentor and student, usually on a one-on-one basis'},
        {value: 'class_observation', label: 'Class Observation'                 ,'description':'A formal or informal observation of teaching while it is taking place in a classroom or other learning environment'},
    ];
    static list_document_types: any = [
        {value: null,label: 'N/A', 'description':''},
        {value: 'course_outline',label: 'Course Outline'                                                        ,'description':'The plan or framework defines objective, learning outcomes and schedule/module of a group'},
        {value: 'scheme_of_work',label: 'Scheme of Work'                                                        ,'description':'The plan defines work to be done in a group/activity'},
        {value: 'program_checklist',label: 'Program Checklist'                                                  ,'description':'A list helps to guide continuous needs assessment and program planning of a group'},
        {value: 'group_adkar',label: 'Group ADKAR'                                                              ,'description':'The assessment of change/impact of a group with the aid of ADKAR'},
        {value: 'baseline_questionnaire_learning_attitude',label: 'Baseline Questionnaire - Learning Attitude'  ,'description':'The quantitative method assessing student’s view on their own learning attitude, when the group starts at each academic year'},
        {value: 'baseline_questionnaire_self_esteem',label: 'Baseline Questionnaire - Self-esteem'              ,'description':'The quantitative method assessing student’s view on their own self-esteem, when the group starts at each academic year'},
        {value: 'year_end_questionnaire_learning_attitude',label: 'Year-end Questionnaire - Learning Attitude'  ,'description':'The quantitative method assessing student’s view on their own learning attitude, when the group ends at each academic year'},
        {value: 'year_end_questionnaire_self_esteem',label: 'Year-end Questionnaire - Self-esteem'              ,'description':'The quantitative method assessing student’s view on their self-esteem, when the group ends at each of academic year'},
        {value : 'others', label: 'Others'                                                                      ,'description':'Any other group/activity/document that does not belong to the preset/mentioned categories'},
    ];

    static list_sub_tier_of_activitys: any = {
            'joint_school_activity' :
                [
                    {value : 'csr_project', label: 'CSR Project'          ,'description':'Group/activity that is cooperated with business/corporate partners'},
                    {value : 'dream_pursuing', label: 'Dream Pursuing' ,'description':'Group/activity relating to inspiring future aspiration'},
                    {value : 'broad_game', label: 'Board Game'            ,'description':'Group/activity that employs board game as a means of intervention'},
                    {value : 'others', label: 'Others'                    ,'description':'Any other group/activity/document that does not belong to the preset/mentioned categories'},
                ],
            'school_based_activity' :
                [
                    {value : 'dream_pursuing', label: 'Dream Pursuing'   ,'description':'Group/activity relating to inspiring future aspiration'},
                    {value : 'english_ambassador', label: 'English Ambassador'  ,'description':'Group/activity to train up students’ skills in organizing activities and promoting an English speaking environment in the school'},
                    {value : 'broad_game', label: 'Board Game'                  ,'description':'Group/activity that employs board game as a means of intervention'},
                    {value : 'csr_project', label: 'CSR Project'                ,'description':'Group/activity that is cooperated with business/corporate partners'},
                    {value : 'others', label: 'Others'                          ,'description':'Any other group/activity/document that does not belong to the preset/mentioned categories'},
                ],
            'group_learning_support' :
                [
                    {value : 'in_class_learning_support', label: 'In-class Learning Support'          ,'description':'Learning group conducted during regular class time'},
                    {value : 'out_of_class_learning_support', label: 'Out of Class Learning Support'  ,'description':'Learning group conducted out of regular class time'},
                    {value : 'others', label: 'Others'                                                ,'description':'Any other group/activity/document that does not belong to the preset/mentioned categories'},
                ],
            'individual_mentoring' :
              [
                {value : 'group_mentoring', label: 'Group Mentoring'            ,'description':'Individual development activity that mentor(s) work with multiple students in a group setting. Although structured as a group, learning is individual and each mentee works on his or her own unique learning needs and development goals.'},
                {value : 'one_on_one_mentoring', label: 'One-on-one Mentoring'  ,'description':'Individual development activity that mentor(s) work with one student only in each meeting.'},
              ],
        };
    static list_settings: any =  [
        {'value'     : 'teaching_large'         ,'label' : 'Teaching (large)'           ,'description':'Conduct of large group lessons/activities for 11 or more students, with a syllabus to follow'},
        {'value'     : 'teaching_small'         ,'label' : 'Teaching (small)'           ,'description':'Conduct of small group lessons/activities for 10 or less students, with a syllabus to follow'},
        {'value'     : 'activity_group_large'   ,'label' : 'Activity Group (large)'     ,'description':'Conduct of large group activities for 11 or more students, without a syllabus to follow'},
        {'value'     : 'activity_group_small'   ,'label' : 'Activity Group (small)'     ,'description':'Conduct of small group activities for 10 or less students, without a syllabus to follow'},
        {'value'     : 'other_mentee'           ,'label' : 'Other Mentee'               ,'description':'Mentees who are not assigned to any other groups'}
    ];
    static list_timeslots: any = [
        {'value'     : 'before_class'     ,'label'     : 'Before class'     ,'description':'The time before a school day starts'},
        {'value'     : 'in_class'         ,'label'     : 'In-class'         ,'description':'The time in regular class of a school day'},
        {'value'     : 'free_lesson'      ,'label'     : 'Free lesson'      ,'description':'The time when a student do not need to attend a regular class in a school day'},
        {'value'     : 'recess'           ,'label'     : 'Recess'           ,'description':'The time of scheduled short break in a school day'},
        {'value'     : 'lunchtime'        ,'label'     : 'Lunchtime'        ,'description':'The time of scheduled lunch break in a school day'},
        {'value'     : 'after_school'     ,'label'     : 'After school'     ,'description':'The time when a school day finishes'},
        {'value'     : 'school_holiday'   ,'label'     : 'School holiday'   ,'description':'The time when students do not need to go to school'},
        {'value'     : 'unknown'           ,'label'    : 'Unknown'          ,'description':'Unspecified timeslot'},
    ];
    static list_object_tive: any = [
        {'value'     : 'mentoring', 'label'     : 'Mentoring', 'description': 'To enhance learning attitudes, motivation and confidence of the students thru various group and individual activities.'},
        {'value'     : 'teaching',  'label'     : 'Teaching', 'description': 'To offer academic instructions in accordance of the curriculum.'},
        {'value'     : 'tutoring',  'label'     : 'Tutoring', 'description': 'To offer supplementary, customized academic support.'},
        {'value'     : 'skill_training', 'label': 'Skill Training', 'description': 'To offer training of specific skill(s) to students.'},
    ];
    static list_activity_type: any = [
        {'value'     : 'lecture_ppt', 'label' : 'Lecture / PPT', 'description': 'Presentation by the mentor with or without the aid of powerpoint.'},
        {'value'     : 'structured_discussions',  'label': 'Structured Discussions', 'description': 'Engagement of the group in discussions with a pre-set agenda and objectives.'},
        {'value'     : 'video_movie',  'label': 'Video / Movie', 'description': 'Presentation of a video or movie, with or without a follow up discussion.'},
        {'value'     : 'group_games', 'label': 'Group Games', 'description': 'Engagement of the group in an activity or activities for joy and amusement, with or without a clear learning objective(s).'},
        {'value'     : 'integrated_tasks', 'label': 'Integrated Tasks', 'description': 'Engagement of the group in certain works or exercises with clear instructions and expectations; and a clear learning objective(s).'},
        {'value'     : 'personal_discussions', 'label': 'Personal Discussions', 'description': 'Sharing and discussions of personal issues, including but not limited to, learning challenges, personal matters, future plan, etc.'},
        {'value'     : 'chatting',  'label': 'Chatting', 'description': 'Talk in a friendly, informal manner.'},
        {'value'     : 'others', 'label': 'Others', 'description': 'Any other activities that fall outside of the above categories.'},
    ];

    // realTime => Button option: Connect/ No Response
    // !realTime => Button option: Present/ Excused Absent/ Unexcused Absent
    static list_contact_means_type: any = [
        {'value'    : 'Face-to-Face', 'label': 'Face-to-Face', 'realtime': false},
        {'value'    : 'Google Meet', 'label': 'Google Meet', 'realTime': false},
        {'value'    : 'Instagram Direct Message', 'label': 'Instagram Direct Message', 'realTime': true},
        {'value'    : 'Phone call', 'label': 'Phone call', 'realTime': true},
        {'value'    : 'Whatsapp', 'label': 'Whatsapp', 'realTime': true},
        {'value'    : 'Whatsapp call', 'label': 'Whatsapp call', 'realTime': true},
        {'value'    : 'Wechat', 'label': 'Wechat', 'realTime': true},
        {'value'    : 'Wechat call', 'label': 'Wechat call', 'realTime': true},
        {'value'    : 'Zoom', 'label': 'Zoom', 'realTime': false},
        {'value'    : 'Microsoft Teams', 'label': 'Microsoft Teams', 'realTime': true},
        {'value'    : 'Others (Real time)', 'label': 'Others (Real time)', 'realTime': true},
        {'value'    : 'Others (Non-real time)', 'label': 'Others (Non-real time)', 'realTime': false},

    ]

    static getIsRealTimeType(contact_means_val){
        const contact_means_type = this.list_contact_means_type.find(item => item.value === contact_means_val);
        if(contact_means_type){
            return contact_means_type.realTime;
        } else{
            return false;
        }

    }

    static list_frequence: any = [
        {value: null,label: 'N/A'},
        {'value'    : 'sometimes', 'label': 'Once/A few times'},
        {'value'    : 'most_of_time', 'label': 'Sometimes'},
        {'value'    : 'all_the_event', 'label': 'Most of the time'},
    ];
    static list_class_size: any = [
      {'value'    : 'whole_class' , 'label': 'Whole class'  ,'description':'Conduct of activity for whole class of student'},
      {'value'    : 'large'       , 'label': 'Large'        ,'description':'Conduct of group /activity for 11 or more students'},
      {'value'    : 'small'       , 'label': 'Small'        ,'description':'Conduct of group /activity for 10 or less students'},
      {'value'    : 'one'         , 'label': 'One'          ,'description':'Conduct of activity for one student'},
    ];
  static list_school_syllabus: any = [
    {'value'    : true , 'label': 'Yes (School Syllabus)' ,'description':'Conduct of group/activity with a syllabus to follow or integrate'},
    {'value'    : false, 'label': 'No (School Syllabus)'  ,'description':'Conduct of group/activity without a syllabus to follow or integrate'},
  ];
    static list_remark_other_behavior: any = [
      {value: '' ,label: 'N/A'},
      {'value'    : 'chat_with_others/distracted', 'label': 'Chat with others/Distracted'},
      {'value'    : 'sleeping/lying_on_the_table', 'label': 'Sleeping/Lying on the table'},
      {'value'    : 'shy/quiet/not_confident_to_speak', 'label': 'Shy/Quiet/Not confident to speak'},
      {'value'    : 'slow_learner', 'label': 'Slow learner'},
      {'value'    : 'was_not_feeling_well_today', 'label': 'Was not feeling well today'},
      {'value'    : 'not_cooperative', 'label': 'Not cooperative'},
      {'value'    : 'willing_to_help_others', 'label': 'Willing to help others'},
      {'value'    : 'refused_to_work_with_others', 'label': 'Refused to work with others'},
      {'value'    : 'used_mobile_phone', 'label': 'Used mobile phone'},
      {'value'    : 'highly_reluctant_to_work_with_others', 'label': 'Highly reluctant to work with others'},
    ];

    static list_group_document_type = [
        {value: 'course_outline',label: 'Course Outline'},
        {value: 'scheme_of_work',label: 'Scheme of Work'},
        {value: 'program_checklist',label: 'Program Checklist'},
        {value: 'group_adkar',label: 'Group ADKAR'},
        {value: 'baseline_questionnaire_learning_attitude',label: 'Baseline Questionnaire - Learning Attitude'},
        {value: 'baseline_questionnaire_self_esteem',label: 'Baseline Questionnaire - Self-esteem'},
        {value: 'year_end_questionnaire_learning_attitude',label: 'Year-end Questionnaire - Learning Attitude,'},
        {value: 'year_end_questionnaire_self_seteem',label: 'Year-end Questionnaire - Self-esteem'},
        {value: 'others',label: 'Others'},
    ];

  static list_student_document_type = [
    {value: 'baseline_interview',label:'Baseline Interview'       , 'description': 'The qualitative method assessing student’s view on their learning attitude, self-esteem and motivation when the group starts at each academic year'},
    {value: 'year_end_interview',label:'Year end Interview'       , 'description': 'The qualitative method assessing student’s view on their learning attitude, self-esteem and motivation when the group ends at each academic year'},
    {value: 'mentoring_plan',label:'Mentoring Plan'               , 'description': 'Mutual agreed plan and objective between mentor and mentee'},
    {value: 'behavioural_checklist',label:'Behavioural Checklist' , 'description': 'A list helps to assess the learning and developmental needs of students before the kickoff of a new group'},
    {value: 'others',label:'Others'},
  ];

  static list_activity_document_type = [
    {value: 'lesson_plan',label:'Lesson Plan'                     , 'description': 'Detailed description of the course of instruction or "learning trajectory" for a lesson with both objectives for learning need and developmental need'},
    {value: 'lesson_powerpoint',label:'Lesson PowerPoint'         , 'description': 'PowerPoint used for a lesson'},
    {value: 'lesson_worksheet',label:'Lesson Worksheet'           , 'description': 'Worksheet or course work materials used for a lesson'},
    {value: 'others',label:'Others'},
  ];

    static list_indicator_label_type = [{
        label: "Option based",
        value: "option_based",
        description: 'Indicator(s) measure in term of choosing from a list of statements or values'
    }, {
        label: "Score based",
        value: "score_based",
        description: 'Indicator(s) measure in term of numerical value'
    }];

  static LIST_TABLE_CORE: any = [];
    static list_cache_fileonedata: any = {};
    static ROLE: any = {};
    static ngay_nghi = {
        '2017-12-30': true,
        '2017-12-31': true,
        '2018-01-01': true,
        '2018-02-14': true,
        '2018-02-15': true,
        '2018-02-16': true,
        '2018-02-19': true,
        '2018-02-20': true,
        '2018-04-25': true,
        '2018-04-30': true,
        '2018-05-01': true,
        '2018-09-03': true,
    };
    static DEFER = new Deferred();
    static TIMESTAMPNOW: any = new Date().getTime();
    static FILTER = {
        LIST_FILTER: [],
    };
    static contains(s, a) {
        return GlobalFunction.is_array(a) && a.filter(e => { return e == s }).length ? true : false;
    }

    static encodeQuote(str) {
        return str.replace(/"/gi, '&quot;').replace(/'/gi, '&#039;');
    }

    static stripUnicode(str, doi) {
        if (!str || str === undefined) {
            return '';
        }
        if (typeof (str) != 'string') {
            return str;
        }
        str = str.trim();
        if (doi === undefined) { doi = '_'; }
        var arrayPregReplace = {
            'à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ|À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ|A|ầ|à': 'a',
            'è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ|È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ|E': 'e',
            'ì|í|ị|ỉ|ĩ|Ì|Í|Ị|Ỉ|Ĩ|I': 'i',
            'ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ|Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ|O': 'o',
            'ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ|Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ|U': 'u',
            'ỳ|ý|ỵ|ỷ|ỹ|Ỳ|Ý|Ỵ|Ỷ|Ỹ|Y': 'y',
            'đ|Đ|D': 'd',
            '[^a-zA-Z0-9 ]+': ' ',
            '[ ]+': ' ',
        };
        for (var key in arrayPregReplace) {
            var re = new RegExp(key, 'gi');
            str = str.replace(re, arrayPregReplace[key]);
        }
        str = str.toLowerCase().trim();
        str = str.replace(/ /gi, doi);
        return str;
    }

    static validateEmail(val) {
        if (val && !val.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gi)) {
            return false;
        }
        return true;
    }

    static validatePhone(val) {
        if (val) {
            let phone = val.replace(/ |\(|\)/gi, '');
            if (phone && !phone.match(/^(0|\+84)[0-9]{6,11}$/gi)) {
                return false;
            }
        }
        return true;
    }

    static validateSize(val, size) {
        if (val && val.length > size) {
            return false;
        }
        return true;
    }

    static validateMin(val, min) {
        if (val && val.length < min) {
            return false;
        }
        return true;
    }

    static validateRegex(vl, regex) {
        if (vl) {
            var r = new RegExp(regex, 'gi');
            if (!vl.match(r)) {
                return false;
            }
        }
        return true;
    }

    static validateVat(val) {
        if (val && !val.match(/^[0-9]{1,25}$/gi)) {
            return false;
        }
        return true;
    }

    static validateDate(val) {
        if (val && (val !== undefined) && (val != '0000-00-00')) {
            if (typeof (val) == 'string') {
                val = val.replace(/T.*/gi, '');
                var date = GlobalFunction.newDate(val);
                if (date) {
                    var d = GlobalFunction.formatDateTime(date, 'y-m-d');
                    return d != val ? false : true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        }
        return true;
    }

    static cloneFunc(that) {
        var temp = function temporary() { return that.apply(this, arguments); };
        temp.prototype = Object.assign({}, that.prototype);
        return temp;
    };

    static getDateNow() {
        let d = GlobalFunction.newDate();
        return d.getFullYear() + '-' + (d.getMonth() + 1 < 10 ? ('0' + (d.getMonth() + 1)) : d.getMonth() + 1) + '-' + (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
    }

    static validateDatePast(val) {
        if (val && GlobalFunction.newDate(val).getTime() > GlobalFunction.newDate(GlobalFunction.getDateNow()).getTime()) {
            return false;
        }
        return true;
    }

    static validateInteger(val) {
        if (val && !isNaN(val) && Number.isInteger(parseFloat(val))) {
            return true;
        }
        return false;
    }

    static validateMinmax(val, range) {
        if (this.validateInteger(val)) {
            if (range && 0 < range.length && range[0] <= val && range[1] > val) {
                return true;
            }
            return false;
        }
        return false;
    }

    static is_array(a) {
        if (a instanceof Array) {
            return true;
        } else {
            return false;
        }
    }

    static validatePositiveNumber(val) {
        if (val <= 0) {
            return false;
        }
        return true;
    }

    static validateFacebookid(val) {
        return val.match(/^[0-9]{7,16}/gi) && val[0] != '0';
    }

    static validatePassword(val) {
        if (val && val.length < 6) {
            return false;
        }
        return true;
    }

    static subString(str, charNum) {
        if (str && charNum) {
            var cn = parseInt(charNum);
            if (str.length > cn) {
                var firstStr = str.substring(0, cn),
                    secondStr = str.substring(cn, str.length),
                    tempStr = secondStr.split(/[.?!,; ]/)[0];
                return firstStr.concat(tempStr);
            }
            else {
                return str;
            }
        }
        return "";
    }

    static addZeroPrefix(number) {
        return 10 > number ? '0' + number : + number;
    }

    static formatTime(timeStr) {
        if (timeStr) {
            let timeArr = timeStr.split(/[^0-9]/),
                y = timeArr[2].length < 4 ? timeArr[0] : timeArr[2],
                m = timeArr[1],
                d = timeArr[0].length < 4 ? timeArr[0] : timeArr[2],
                h = timeArr[3],
                mi = timeArr[4],
                s = timeArr[5]
            return {
                'hhmmss': h + ':' + mi + ':' + s,
                'ddmmyyyy': d + '/' + m + '/' + y,
                'ddmm': d + '/' + m,
                'ddmmyyHHMM': d + '/' + m + '/' + y + ' ' + h + ':' + mi + ':' + s + (parseInt(h) > 12 ? 'PM' : 'AM')
            };
        }
    }

    static get24HoursValue(milliseconds) {
      let dt = new Date(milliseconds);
      let hours = dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours();
      let minutes = dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes();
      return hours + ':' + minutes;
    }

    static formatDateTime(date, format_date = 'd-t-y H:i') {
        function prettyDateMonth(m_d) {
            if (m_d < 10) { m_d = '0' + m_d };
            return m_d;
        }
        if (!date || (typeof (date) == 'object' && !date.getFullYear)) {
            return '';
        }
        if (typeof (date) == 'number') {
            if (('' + date).length == 10) {
                date = date * 1000;
            }
        }
        switch (typeof (date)) {
            case 'string': date = GlobalFunction.newDate(date); break;
            case 'number': date = GlobalFunction.newDate(date); break;
        }
        var rs = format_date.toLowerCase();
        var attr = {
            'd': prettyDateMonth(date.getDate()),
            'm': prettyDateMonth(date.getMonth() + 1),
            'y': date.getFullYear(),
            'h': prettyDateMonth(date.getHours()),
            'i': prettyDateMonth(date.getMinutes()),
            's': prettyDateMonth(date.getSeconds()),
            't': prettyDateMonth(date.getMonth() + 1),
        };
        for (var i in attr) {
            rs = rs.replace(i, attr[i]);
        }
        if (-1 != rs.indexOf('NaN')) {
            return '';
        }
        return rs;
    }
    static timeToStr(timeObj, strFormat) {
        if (timeObj && Object.prototype.toString.call(timeObj) === "[object Date]") {
            let y = timeObj.getFullYear(),
                m = timeObj.getMonth() + 1,
                d = timeObj.getDate(),
                h = timeObj.getHours(),
                mi = timeObj.getMinutes(),
                s = timeObj.getSeconds();
            let addZero = (t) => { return t < 10 ? '0' + t : t; }

            return {
                'hm': addZero(h) + ':' + addZero(mi),
                'dmy': addZero(d) + '/' + addZero(m) + '/' + y,
                'full': y + '-' + addZero(m) + '-' + addZero(d) + ' ' + addZero(h) + ':' + addZero(mi) + ':' + addZero(s)
            }[strFormat];
        } else {
            return '--:--';
        }
    }

    static replaceBreakLine(str: string) {
        return str.replace(/[\r\n]/g, "<br>");
    }

    static validateNameFacebook(val: string) {
        return val.match(/^[a-zA-Z0-9\._-]+$/gi);
    }

    static get_url_param_by_object(obj) {
        // var rs = [];
        // for (var i in obj) {
        //     rs.push(i + '=' + encodeURIComponent(typeof (obj[i]) == 'object' ? JSON.stringify(obj[i]) : obj[i]));
        // }
        // return rs.join('&');
        const queryString = qs.stringify(obj, {
            arrayFormat: 'repeat'
        });
        return queryString;
    }

    static newDate(date = undefined) {
        var dd = undefined;
        if (typeof (date) == 'string') {
            date = date.replace('thg ', '');
            dd = new Date(date);
        } else if (typeof (date) == 'number') {
            if (('' + date).length == 10) {
                date *= 1000;
            }
            dd = new Date(date);
        } else if (!date || date === undefined) {
            dd = new Date(GlobalFunction.TIMESTAMPNOW);
        }

        if (dd === undefined) {
            dd = new Date(date.getTime());
        }
        return dd;
    }

    static cloneObj(obj) {
        var o = Object.assign({}, obj);
        if (obj['__proto__'] && obj['__proto__'] !== undefined) {
            o['__proto__'] = Object.assign({}, obj['__proto__']);
        }
        if (obj['__proto__']['__proto__'] && obj['__proto__']['__proto__'] !== undefined) {
            o['__proto__']['__proto__'] = Object.assign({}, obj['__proto__']['__proto__']);
        }
        return o;
    }

    static getTimestampnow(d = undefined) {
        var d = GlobalFunction.newDate(d);
        return Math.floor(d.getTime() / 1000);
    }

    static convertInputDateYMDToMilliseconds(d = undefined) {
      let dateS = d + ' 00:00:00';
      return new Date(dateS).getTime();
    }

    static capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    static searchToObject() {
        if (!window.location.search) {
            return {};
        }
        var pairs = window.location.search.substring(1).split("&"), obj = {}, pair, i;

        for (i in pairs) {
            if (pairs[i] === "") continue;

            pair = pairs[i].split("=");
            obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
        }

        return obj;
    }

    static createLocalStorageEntry(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    static getLocalStorageEntry(key) {
        const entry = localStorage.getItem(key);
        return JSON.parse(entry);
    }

    static removeLocalStorageEntry(key) {
        localStorage.removeItem(key);
    }

    static createCookie(name, value, days = 0) {
        if (name === 'user_info') {
          return localStorage.setItem(name, value);
        }
        // if(sessionStorage && !days) {
        //     sessionStorage[name] = value;
        //     return;
        // }
        var expires = ";expires=0";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        } else if (document['documentMode'] > 0) {
            expires = ";";
        }
        document.cookie = name + "=" + value + expires + "; path=/";
        return value;
    }

    static readCookie(name) {
        if (name === 'user_info') {
          return JSON.parse(localStorage.getItem('user_info'));
        }
        // if (sessionStorage[name]) {
        //     return sessionStorage[name];
        // }
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        var value = null;
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) {
                value = c.substring(nameEQ.length, c.length);
                break;
            }
        }
        return value;
    }

    static removeCookie(name) {
        // delete sessionStorage[name];
        if (name === 'user_info') {
          return localStorage.removeItem('user_info');
        }
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
    }

    static setTimeout(time) {
        var def = new Deferred();
        setTimeout(function () {
            def.resolve(true);
        }, time);
        return def.promise;
    }

    static index(rs, key) {
        var list = {};
        if (rs) {
            for (var i in rs) {
                if (rs[i] && typeof (rs[i]) == 'object') {
                    list[rs[i][key]] = rs[i];
                }
            }
        }
        return list;
    }

    static indexArray(rs, key) {
        var list = [];
        if (rs) {
            for (var i in rs) {
                list.push(rs[i][key]);
            }
        }
        return list;
    }

    static indexObj(rs, key, value) {
        var list = {};
        if (rs) {
            for (var i in rs) {
              if (rs[i][value]) {
                list[rs[i][key]] = rs[i][value];
              }
            }
        }
        return list;
    }

    static time_minute_second(time) {
        if (!time) {
            return '00:00';
        }
        var d = Math.floor(time / (60 * 60 * 24));
        var a = time % (60 * 60 * 24);
        var h = Math.floor(a / (60 * 60));
        h += d * 24;
        a = a % (60 * 60);
        var temp = Math.floor(a / 60);
        var m = '' + temp;
        if (temp < 10) {
            m = '0' + temp;
        }
        var temp = a % 60;
        var s = '' + temp;
        if (temp < 10) {
            s = '0' + s;
        }
        // var dd = d ? d + 'd ' : '';
        var hh = h ? (h < 10 ? '0' + h : h) + ':' : '00:';
        var ms = m;
        // ms += ":" + s + '';
        return hh + ms;
    }

    static upperFristWord(str) {
        var array_str = str.split('_');
        var str_new = '';
        for (var i in array_str) {
            str_new += GlobalFunction.capitalizeFirstLetter(array_str[i]);
        }
        return str_new;
    }

    static getDateExpected(date_expected) {
        var date = GlobalFunction.newDate(date_expected);
        var count = 0;
        for (var i = 1; i < 14; i++) {
            if (date.getDay() == 0 || date.getDay() == 6 || GlobalFunction.ngay_nghi[GlobalFunction.formatDateTime(date, 'y-m-d')]) {
                date.setDate(date.getDate() + 1);
                if (i == 0) {
                    date.setHours(7);
                    date.setMinutes(59);
                    date.setSeconds(0);
                }
                continue;
            }
            count++;
            if ((date.getHours() >= 8 && count == 3) || (date.getHours() < 8 && count == 2)) {
                break;
            }
            date.setDate(date.getDate() + 1);
        }
        if (date.getHours() >= 17 || date.getHours() < 8) {
            date.setHours(17);
            date.setMinutes(0);
            date.setSeconds(0);
        }
        return GlobalFunction.formatDateTime(date, 'd-t-y h:i');
    }

    static get_date_process_time(value) {
        var date_value = GlobalFunction.newDate(value);
        if (date_value.toString() == 'Invalid Date') {
            return false;
        }
        if (date_value.getDay() == 0 || date_value.getDay() == 6 || GlobalFunction.ngay_nghi[GlobalFunction.formatDateTime(date_value, 'y-m-d')]) {
            date_value.setHours(17);
            date_value.setMinutes(0);
            date_value.setSeconds(0);
        }
        if (date_value.getHours() >= 17) {
            date_value.setHours(17);
            date_value.setMinutes(0);
            date_value.setSeconds(0);
        } else if (date_value.getHours() < 8) {
            date_value.setHours(8);
            date_value.setMinutes(0);
            date_value.setSeconds(0);
        } else if (date_value.getHours() == 12) {
            date_value.setHours(12);
            date_value.setMinutes(0);
            date_value.setSeconds(0);
        }
        return date_value;
    }

    static get_process_date_now(date_now = undefined) {
        var date_value = GlobalFunction.newDate(date_now);
        if (date_value.toString() == 'Invalid Date') {
            return false;
        }
        if (date_value.getDay() == 0 || date_value.getDay() == 6 || GlobalFunction.ngay_nghi[GlobalFunction.formatDateTime(date_value, 'y-m-d')]) {
            date_value.setHours(8);
            date_value.setMinutes(0);
            date_value.setSeconds(0);
        }
        if (date_value.getHours() >= 17) {
            date_value.setHours(17);
            date_value.setMinutes(0);
            date_value.setSeconds(0);
        } else if (date_value.getHours() < 8) {
            date_value.setHours(8);
            date_value.setMinutes(0);
            date_value.setSeconds(0);
        } else if (date_value.getHours() == 12) {
            date_value.setHours(12);
            date_value.setMinutes(0);
            date_value.setSeconds(0);
        }
        return date_value;
    }
    static compare_date_str(val1, val2) {
        if (val1 && val2) {
            try {
                var d1 = new Date(val1);
                var d2 = new Date(val2);
                if (d1.getFullYear() == d2.getFullYear() &&
                    d1.getMonth() == d2.getMonth() &&
                    d1.getDate() == d2.getDate()) {
                    return true;
                }
                return false;
            } catch (e) {
                console.log('error parse date');
                return false;
            }
        }
        return false;
    }

    static number_format(so1) {
        so1 = '' + so1;
        if (typeof (so1) == 'string' && so1) {
            so1 = $.trim(so1);
        }
        var so = (so1 != '0' && so1 != '') ? String(so1.replace(/([^0-9.])+|^(0)+/gi, '')) : so1;
        var sotp = so.split('.');
        so = sotp[0];
        var xau2 = '';
        if (sotp.length > 1) {
            sotp[0] = '';
            xau2 = sotp.join('');
        }
        var mangso = so.split("");
        var count = mangso.length;
        var xau = "";
        var j = 1;
        for (var i = count - 1; i >= 0; i--) {
            xau = String(mangso[i]) + xau;
            if (j % 3 == 0 && j != count)
                xau = "," + xau;
            j++;

        }
        if (sotp.length > 1) {
            xau += '.' + xau2;
        }
        return xau;
    }

    static number_percent(so1) {
        so1 = '' + so1;
        if (typeof (so1) == 'string' && so1) {
            so1 = $.trim(so1);
        }

        if (so1 != "") {
            var mangso = so1.split('.');
            so1 = mangso[0];
        }
        var so = typeof (so1) == 'string' ? so1.replace(/(\D)+/gi, '') : so1;
        var so2 = parseInt(so);
        if (so2 > 100)
            so = 100;
        return so + '%';
    }


    static get_process_time(value, date_now = undefined) {
        var value_date = GlobalFunction.get_date_process_time(value);
        if (value_date === false) {
            return '';
        }
        var value_date_new = GlobalFunction.newDate(GlobalFunction.formatDateTime(value, 'y-m-d'));

        var date = GlobalFunction.get_process_date_now(date_now);
        if (date === false) {
            return '';
        }
        var date_new = GlobalFunction.newDate(GlobalFunction.formatDateTime(date, 'y-m-d'));

        var timestamp_value_date_new = Math.floor(value_date_new.getTime() / 1000);
        var timestamp_date_new = Math.floor(date_new.getTime() / 1000);

        if (value_date.getTime() > date.getTime()) {
            return '';
        }
        var total = 0;
        if (timestamp_date_new == timestamp_value_date_new) {
            total = Math.floor(date.getTime() / 1000) - Math.floor(value_date.getTime() / 1000);
            if (date.getHours() >= 13 && value_date.getHours() <= 12) {
                total -= 3600;
            }
        } else {
            while (timestamp_date_new >= timestamp_value_date_new) {

                if (value_date_new.getDay() != 0 && value_date_new.getDay() != 6 && !GlobalFunction.ngay_nghi[GlobalFunction.formatDateTime(value_date_new, 'y-m-d')]) {
                    if (timestamp_value_date_new == timestamp_date_new) {
                        total += Math.floor(date.getTime() / 1000) - Math.floor(value_date.getTime() / 1000);
                        if (date.getHours() >= 13 && value_date.getHours() <= 12) {
                            total -= 3600;
                        }
                    } else {
                        var date_new_2 = GlobalFunction.newDate(value_date);
                        date_new_2.setHours(17);
                        date_new_2.setMinutes(0);
                        date_new_2.setSeconds(0);
                        total += Math.floor(GlobalFunction.newDate(date_new_2).getTime() / 1000) - Math.floor(value_date.getTime() / 1000);
                        if (date_new_2.getHours() >= 13 && value_date.getHours() <= 12) {
                            total -= 3600;
                        }
                    }
                }
                value_date.setDate(value_date.getDate() + 1);
                value_date.setHours(8);
                value_date.setMinutes(0);
                value_date.setSeconds(0);
                value_date_new.setDate(value_date_new.getDate() + 1);
                timestamp_value_date_new = Math.floor(value_date_new.getTime() / 1000);
            }
        }

        return GlobalFunction.time_minute_second(total);
    }

    static getNamePrintCard(name) {
        var name = GlobalFunction.stripUnicode(name, ' ').toUpperCase();
        if (name.length > 19) {
            var a = name.split(' ');
            if (a.length >= 3) {
                var rs = [a[0]];
                var i = 0;
                do {
                    i++;
                    a[i] = a[i][0];
                    name = a.join(' ');
                } while (name.length > 19 && i < a.length - 2);
            }
        }
        name = name.substr(0, 19);
        return name;
    }

    static check_file(file) {
        var a = file.type.split('/');
        var name = file.name.toLowerCase();
        var flag = false;
        if (name.match(/\.(rar|zip)$/gi)) {
            flag = true;
        } else {
            if (a.length == 2 && GlobalFunction.contains(a[1], ['plain', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'msword', 'pdf', 'vnd.ms-excel', 'x-zip-compressed', 'vnd.openxmlformats-officedocument.wordprocessingml.document'])) {
                flag = true;
            }
        }
        return flag;
    }

    static check_image(file) {
        var a = file.type.split('/');
        return a[0] == 'image';
    }

    static get_model_service_by_table_name(table_name) {
        return table_name.replace(/(^[a-z])|_([a-z])/gi, function (match) {
            return match.replace('_', '').toUpperCase();
        }) + 'Service';

    }

    static searchInArrayObject(search, array, attribute) {
        var results = [];
        var labelTemp = '';
        if (search) {
            for (var i in array) {
                labelTemp = GlobalFunction.stripUnicode(array[i][attribute], ' ');
                search = GlobalFunction.stripUnicode(search, ' ');
                if (labelTemp.includes(search)) {
                    results.push(array[i]);
                }
            }
            return results;
        } else {
            return array;
        }
    }

    static cloneArray(obj) {
        var output, value, key;
        output = Array.isArray(obj) ? [] : {};
        for (key in obj) {
            value = obj[key];
            output[key] = (typeof value === "object") ? this.cloneArray(value) : value;
        }
        return output;
    }
    /**
     * get distance between 2 point theo duong chim bay
     * @param p1 , p2 Point
     * @return distance 2 poin in meter
     */
    static getDistance = function (p1, p2) {
        if (p1 && p2) {
            var rad = function (x) {
                return x * Math.PI / 180;
            };
            var R = 6378137; // Earth’s mean radius in meter
            var dLat = rad(p2.lat - p1.lat);
            var dLong = rad(p2.lng - p1.lng);
            var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) *
                Math.sin(dLong / 2) * Math.sin(dLong / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = R * c;
            return d; // returns the distance in meter
        }
        return null;
    };

    /**
     * get link url map in google
     */
    static glinkMap(type, params) {
        var link = "";
        var parameters = "";
        if (typeof (params) == "object") {
            parameters = GlobalFunction.serialize(params, null);
        }
        type = type.toUpperCase();
        switch (type) {
            case "SEARCH": link = CONFIG.GMAP.SEARCH; break;
            case "DIRECTIONS": link = CONFIG.GMAP.DIRECTIONS; break;
            case "DISPLAY.MAP": link = CONFIG.GMAP.DISPLAY.MAP; break;
            case "DISPLAY.PANO": link = CONFIG.GMAP.DISPLAY.PANO; break;
            default: link = CONFIG.GMAP.SEARCH;
        }
        if (parameters) {
            return link.replace("parameters", parameters.toString());
        }
        return link.replace("&parameters", "");
    }

    static serialize = function (obj, prefix) {
        var str = [],
            p;
        for (p in obj) {
            if (obj.hasOwnProperty(p)) {
                var k = prefix ? prefix + "[" + p + "]" : p,
                    v = obj[p];
                str.push((v !== null && typeof v === "object") ?
                    GlobalFunction.serialize(v, k) :
                    encodeURIComponent(k) + "=" + encodeURIComponent(v));
            }
        }
        return str.join("&");
    }

    static processTimeRange(mode = 2) {
        var start: any = this.formatChartTime(GlobalFunction.newDate());
        var end: any = this.formatChartTime(GlobalFunction.newDate());
        var now: any = this.formatChartTime(GlobalFunction.newDate());
        /**
         *  mode 0 : today
         *       1 : yesterday
         *       2 : last week
         *       3 : last month
         *       4 :  last 7 days
         *       5 :  last 30 days
         */
        switch (mode.toString()) {
            case '0':
                start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
                end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
                break;
            case '1':
                start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 0, 0, 0);
                end = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 23, 59, 59);
                break;
            case '3':
                start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                end = new Date(now.getFullYear(), now.getMonth(), 0);
                break;
            case '4':
                start.setDate(now.getDate() - 6);

                break;
            case '5':
                start.setDate(now.getDate() - 29);

                break;
            case '2':
            default:
                start.setDate(now.getDate() - now.getDay() - 6);
                end.setDate(now.getDate() - now.getDay());
                break;
        }
        return { start: start, end: end }
    }

    static calculateTimeRange(first, second) {
        var oneDay = 24 * 60 * 60 * 1000;
        return Math.round(Math.abs(first.getTime() - second.getTime()) / oneDay);
    }

    /**
     * get number of day by mode
     * @return number
     */
    static totalTimeRange(mode = 2) {
        switch (mode) {
            case 0:
            case 1: return 1;
            case 2:
            case 4: return 7;
            case 5: return 30;
            case 3: return GlobalFunction.daysInMonth(new Date().getMonth(), new Date().getFullYear());
        }
        return 1;
    }
    static daysInMonth(month, year) {
        return new Date(year, month, 0).getDate();
    }

    static chosenDateRange() {
        return [
            { id: 0, text: 'Today' },
            { id: 1, text: 'Yesterday' },
            { id: 2, text: 'Last week' },
            { id: 3, text: 'Last month' },
            { id: 4, text: 'Last 7 days' },
            { id: 5, text: 'Last 30 days' }
        ];
    }
    static calc_score_image(val: number) {
        return 1 / (1 + Math.pow(Math.E, -(-167.4 + 180 * val)));
    }

    static formatChartTime(date) {
        var dateTime = GlobalFunction.newDate(date);
        let year = parseInt(dateTime.getFullYear());
        let month = parseInt(dateTime.getMonth());
        let day = parseInt(dateTime.getDate());

        return new Date(year, month, day);
    }
    /**
     * add space after string
     */
    static addSpace(origin, leng, space = " ") {
        var origin_leng = origin.length;
        if (origin_leng < leng) {
            for (var i = origin_leng; i < leng; i++) {
                origin += space;
            }
        }
        return origin;
    }

    /**
     * check if arr1 is child of arr2
     */
    static inArray(arr1 = [], arr2 = []) {
        for (var i = 0; i < arr1.length; i++) {
            if (!GlobalFunction.contains(arr1[i], arr2)) {
                return false;
            }
        }
        return true;
    }

    /**
     * check if Object is empty
     */
    static isEmptyObject(obj) {
        if (obj == null) {
            return true;
        }
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop))
                return false;
        }
        return JSON.stringify(obj) === JSON.stringify({});
    }

    static fix_auto_rotate(img, orientation) {
        var md = {};
        if (orientation) {
            md['orientation'] = orientation;
            GlobalFunction.loadImg(img, md, md['orientation']);
        } else {
            EXIF.getData(img, function () {
                var data = EXIF.getAllTags(img);
                md['orientation'] = data.Orientation ? data.Orientation : 1;
                GlobalFunction.loadImg(img, md, md['orientation']);
            });
        }

    }
    /**
     * change phone number to submask phone number
     * @example 12345678 => xxxxxxx678
     * @param phone_number string
     * @param mask string
     * @param length length of last number phone want to show
     */
    static phone_mask(phone_number, mask = "x", length = 2) {
        let rs = "";
        if (phone_number) {
            let phone_leng = phone_number.length;
            let tail = phone_number.substring(phone_leng - length, phone_leng);
            for (let i = 0; i < phone_leng - length; i++) {
                rs += 'x';
            }
            rs += tail;
        }
        return rs;
    }

    static loadImg(img, md, orientation) {
        var width, height, naturalWidth, naturalHeight, offsetTop, offsetLeft;
        var parent_obj = $(img).parent();
        var parent_width = parent_obj.width();
        var parent_height = parent_obj.height();
        $(img).hide();
        var naturalHeight = img.naturalHeight;
        var naturalWidth = img.naturalWidth;
        var old_src = $(img).attr('src');
        md['style_img'] = {};
        if (orientation == 1) {
            if (naturalWidth > naturalHeight) {
                width = parent_width;
                height = width * naturalHeight / naturalWidth;
            } else {
                height = parent_height;
                width = height * naturalWidth / naturalHeight;
            }
            if (height > parent_height) {
                height = parent_height;
                width = height * naturalWidth / naturalHeight;
            }
            if (width > parent_width) {
                width = parent_width;
                height = width * naturalHeight / naturalWidth;
            }
            offsetLeft = (parent_width - width) / 2;
            offsetTop = (parent_height - height) / 2;
            md['style_img']['top'] = offsetTop + 'px';
            md['style_img']['left'] = offsetLeft + 'px';
            var width_percent = width / naturalWidth;
            var height_percent = height / naturalHeight;
            md['style_img']['transform'] = 'rotate(0deg)';
            md['style_img']['-webkit-transform'] = 'rotate(0deg)';
            md['style_img']['-ms-transform'] = 'rotate(0deg)';
        } else if (orientation == 3) {
            if (naturalWidth > naturalHeight) {
                width = parent_width;
                height = width * naturalHeight / naturalWidth;
            } else {
                height = parent_height;
                width = height * naturalWidth / naturalHeight;
            }
            if (height > parent_height) {
                height = parent_height;
                width = height * naturalWidth / naturalHeight;
            }
            if (width > parent_width) {
                width = parent_width;
                height = width * naturalHeight / naturalWidth;
            }
            offsetLeft = (parent_width - width) / 2;
            offsetTop = (parent_height - height) / 2;
            md['style_img']['top'] = offsetTop + 'px';
            md['style_img']['left'] = offsetLeft + 'px';
            var width_percent = width / naturalWidth;
            var height_percent = height / naturalHeight;
            md['style_img']['transform'] = 'rotate(180deg)';
            md['style_img']['-webkit-transform'] = 'rotate(180deg)';
            md['style_img']['-ms-transform'] = 'rotate(180deg)';
        } else if (orientation == 6) {
            if (naturalWidth > naturalHeight) {
                width = parent_height;
                height = width * naturalHeight / naturalWidth;
            } else {
                height = parent_width;
                width = height * naturalWidth / naturalHeight;
            }
            if (height > parent_height) {
                height = parent_height;
                width = height * naturalWidth / naturalHeight;
            }
            if (width > parent_width) {
                width = parent_width;
                height = width * naturalHeight / naturalWidth;
            }
            md['style_img']['transform'] = 'rotate(90deg)';
            md['style_img']['-webkit-transform'] = 'rotate(90deg)';
            md['style_img']['-ms-transform'] = 'rotate(90deg)';
            offsetLeft = (parent_width - width) / 2;
            offsetTop = (parent_height - height) / 2;
            md['style_img']['top'] = offsetTop + 'px';
            md['style_img']['left'] = offsetLeft + 'px';
            var width_percent = height / naturalWidth;
            var height_percent = width / naturalHeight;
        } else if (orientation == 8) {
            if (img.naturalWidth > naturalHeight) {
                width = parent_height;
                height = width * naturalHeight / naturalWidth;
            } else {
                height = parent_width;
                width = height * naturalWidth / naturalHeight;
            }
            if (height > parent_height) {
                height = parent_height;
                width = height * naturalWidth / naturalHeight;
            }
            if (width > parent_width) {
                width = parent_width;
                height = width * naturalHeight / naturalWidth;
            }
            md['style_img']['transform'] = 'rotate(-90deg)';
            md['style_img']['-webkit-transform'] = 'rotate(-90deg)';
            md['style_img']['-ms-transform'] = 'rotate(-90deg)';
            offsetLeft = (parent_width - width) / 2;
            offsetTop = (parent_height - height) / 2;
            md['style_img']['top'] = offsetTop + 'px';
            md['style_img']['left'] = offsetLeft + 'px';
            var width_percent = height / naturalWidth;
            var height_percent = width / naturalHeight;
        }
        md['style_img']['width'] = width + 'px';
        md['style_img']['height'] = height + 'px';
        md['style_img']['margin'] = '0px';
        $(img).attr('style', "");
        for (var k in md['style_img']) {
            var v = md['style_img'][k];
            $(img).css(k, v);
        }
    }

    static getTimeDiff(date1, date2) {
        const diffSeconds = date2 - date1;

        const diffDays = Math.floor(diffSeconds / 3600 / 24);
        const diffHrs = Math.floor((diffSeconds / 3600));
        const diffMins = Math.round(diffSeconds / 60);
        return {
            diffDays: diffDays,
            diffHrs: diffHrs,
            diffMins: diffMins
        };
    }

    static mapTitle(key, listValue) {
        if (listValue && Array.isArray(listValue) && listValue.length) {
            for (let i in listValue) {
                if (key == listValue[i]['id']) {
                    return listValue[i]['text'];
                }
            }
        }
        return '';
    }

    static getListObjRangeDate() {
        var list_obj = {};
        if (GlobalFunction['academic_years']) {
            let academic_years = GlobalFunction['academic_years'];
            for (let item of academic_years) {
                list_obj[item.academic_year_id] = item.academic_year_id;
            }
        } else {
            var end = GlobalFunction.newDate().getFullYear();
            var start = end - 2;
            for (var i = start; i <= end; i++) {
                var year_start = i + '-01-01';
                var year_end = i + '-12-31';
                var k = GlobalFunction.newDate(year_start).getTime() + ' - ' + (GlobalFunction.newDate(year_end).getTime() + 86399000);
                list_obj[k] = i + '-' + (i + 1);
            }
        }
        return list_obj;
    }

    static getListGender() {
        return [
            {
                'label': "Male",
                'value': "M",
            },
            {
                'label': "Female",
                'value': "F",
            },
        ]
    }
    static get_password_token() {
        let password_token = JSON.parse(localStorage.getItem('password_token'));
        let prefixUrl = localStorage.getItem("prefixUrlRole");
        if (!password_token || password_token == undefined) {
            let object_search = GlobalFunction.searchToObject();
            window.location.href = object_search['urlb'] ? object_search['urlb'] : '#/' + prefixUrl + '/dashboard/index';
        }
        return password_token.token_type + ' ' + password_token.access_token;
    }

    static list_type_schools() {
        return [
            {
                'value': 'co_ed',
                'label': 'Co-ed School',
            },
            {
                'value': 'girl',
                'label': 'Girl\'s School',
            },
            {
                'value': 'boy',
                'label': 'Boy\'s School',
            }
        ];
    }

    /**
     * get list role value => key or {value => value, key=> key}
     * @param obj
     */
    static getListRole(obj = false) {
        if (obj) {
            return [
                {
                    'value': 4,
                    'label': 'Mentor',
                },
                {
                    'value': 1,
                    'label': 'Super Admin',
                },
                {
                    'value': 2,
                    'label': 'System Admin',
                },
                {
                    'value': 3,
                    'label': 'School Admin',
                }
            ];
        }
        return {
            1: 'Super Admin',
            2: 'System Admin',
            3: 'School Admin',
            4: 'Mentor',
        };
    }

  /**
   * get list role value => key or {value => value, key=> key}
   * @param obj
   */
  static getListRoleForSystemAdmin(obj = false) {
    if (obj) {
      return [
        {
          'value': 4,
          'label': 'Mentor',
        },
        {
          'value': 3,
          'label': 'School Admin',
        }
      ];
    }
    return {
      3: 'School Admin',
      4: 'Mentor',
    };
  }

  /**
   * get list role value => key or {value => value, key=> key}
   * @param obj
   */
  static getListRoleForSchoolAdmin(obj = false) {
    if (obj) {
      return [
        {
          'value': 4,
          'label': 'Mentor',
        }
      ];
    }
    return {
      4: 'Mentor',
    };
  }

  static getPrefixUrlRole(role) {
    if (role == 1) {
      return 'superadmin';
    } else if (role == 2) {
      return 'systemadmin';
    } else if (role == 3) {
      return 'schooladmin';
    } else if (role == 4) {
      return 'mentor';
    }
    return '';
  }

    /**
     * get value in array by key
     */
    static getValueByKey(array, key, key_value, map) {
        if (array && key && map) {
            for (let item of array) {
                if (item[key] == key_value) {
                    return item[map];
                }
            }
        }
        return "";
    }

    /**
     * to upper case first character and remove "_"
     */
    static firstUpperCase(str) {
        if (str) {
            // let string = str.replace('_', ' ');
            let arr = str.split(/(?=[_])/);
            let rs  = [];
            for(let i of arr) {
                rs.push(GlobalFunction.capitalizeFirstLetter(i.replace('_','')))
            }
            return rs.join(' ');
        }
        return "";
    }

    static async getAcademicYears(model) {
        if (!GlobalFunction['academic_years']) {
            GlobalFunction['academic_years'] = {};
            // call data get academic_years
            let api = API.GET_ACADEMIC_YEAR;
            api += "?$orderby=from_time%20desc";
            var rs = await model._db.get(api);
            let currentAcademicYears = rs.filter(ay => ay.current);
            if (currentAcademicYears.length > 0) {
                GlobalFunction['current_academic_year'] = currentAcademicYears[0].academic_year_id;
            }
            GlobalFunction['academic_years'] = GlobalFunction.indexObj(rs, 'academic_year_id', 'academic_year_id');
            GlobalFunction['academic_years_obj'] = GlobalFunction.index(rs, 'academic_year_id');
        }
        return GlobalFunction['academic_years'];
    }

    static listTypeDocument() {
        return [
            {
                'value': 'baseline_interview',
                'label': 'Baseline Interview',
                'description':'The qualitative method assessing student’s view on their learning attitude, self-esteem and motivation when the group starts at each academic year'
            },
            {
                'value': 'year_end_interview',
                'label': 'Year end Interview',
                'description':'The qualitative method assessing student’s view on their learning attitude, self-esteem and motivation when the group ends at each academic year'
            },
            {
                'value': 'mentoring_plan',
                'label': 'Mentoring Plan',
                'description':'Mutual agreed plan and objective between mentor and mentee',
            },
            {
                'value': 'behavioural_checklist',
                'label': 'Behavioural Checklist',
                'description':'A list helps to assess the learning and developmental needs of students before the kickoff of a new group',
            },
            {
                'value': 'others',
                'label': 'Others',
                'description':'',
            },
        ];
    }

    static list_stage_of_develop() {
        return [
            {
                'value' : 'targeting',
                'label' : 'Targeting',
            },
            {
                'value' : 'engaging',
                'label' : 'Engaging',
            },
            {
                'value' : 'embedding',
                'label' : 'Embedding',
            },
            {
                'value' : 'sustaining',
                'label' : 'Sustaining',
            },
        ];
    }

    static EmptyObject(obj) {
        if(typeof(obj) == 'object') {
            return Object.keys(obj).length === 0 ? true : false;
        }
        return true;
    }

    static get_list_sub_tier_of_activitys(val) {
        let list_sub_tier_of_activitys = GlobalFunction.list_sub_tier_of_activitys;
        if(list_sub_tier_of_activitys[val] != undefined) {
            return list_sub_tier_of_activitys[val];
        }
        return null;
    }

    static getLabelFromArrayByKey(nameKey, myArray) {
      if (!myArray || myArray.length == 0) {
        return nameKey;
      }
      for (var i = 0; i < myArray.length; i++) {
        if (myArray[i].value === nameKey) {
          return myArray[i].label;
        }
      }
    }
    static getKeyFromArrayByLabel(label, myArray) {
      if (!myArray || myArray.length == 0) {
        return label;
      }
      for (var i = 0; i < myArray.length; i++) {
        if (myArray[i].label === label) {
          return myArray[i].value;
        }
      }
    }

    static clearAuthenInfo() {
      GlobalFunction.removeCookie('token');
      GlobalFunction.removeCookie('password_token');
      GlobalFunction.removeCookie('user_info');
      localStorage.removeItem('emailCurrentUserLogin');
      localStorage.removeItem('prefixUrlRole');
      localStorage.removeItem('profileImageUrlLocalKey');
      localStorage.removeItem('role');
      localStorage.removeItem('roleName');
      localStorage.removeItem('schoolCurrentUserLogin');
      localStorage.removeItem('expires_in');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('last_time_login');
      localStorage.removeItem('token');
      localStorage.removeItem('user_info');
      localStorage.removeItem('password_token');
      localStorage.removeItem('refer_emailCurrentUserLogin');
      localStorage.removeItem('refer_prefixUrlRole');
      localStorage.removeItem('refer_role');
      localStorage.removeItem('refer_roleName');
      localStorage.removeItem('refer_schoolCurrentUserLogin');
    }

    /**
     * Save the content as a file.
     * Browser may download the file directly or
     * show a file saving popup depending on browser setting.
     *
     * @param content - Content to be saved.
     * If content is not string nor Array type
     * the content will be converted to string.
     * If content is Array it will pass to the Blob constructor.
     *
     * @param filename - Filename to be saved.
     *
     * @param options {object=} - Optional options object that may contain any of the following attributes:
     *
     * @param options.encoding {string=} - Encoding used to serialize content.
     * See https://github.com/inexorabletash/text-encoding#encodings
     * for list of supported encoding.
     * Default is UTF-8.
     * This option is not supported when content is Array type.
     *
     * @param options.includeBom {boolean=} - When true and
     * the encoding is unicode, write a BOM to the start of the file.
     * Default is false.
     *
     * @param options.blobPropertyBag {object=} - An options object passed to
     * the 2nd parameter of the Blob constructor.
     * See https://developer.mozilla.org/en-US/docs/Web/API/Blob/Blob
     * for possible attributes of this object.
     * Default is null
     *
     */
    static saveFile(content: any, filename: string, options?: any) {
        options = options || {};
        let includeBom: boolean = options.includeBom;
        let blobPropertyBag: BlobPropertyBag = options.blobPropertyBag;

        let encoding: string = options.encoding;
        if (encoding) {
            encoding = encoding.toLowerCase();
        }
        if (encoding === 'utf-8' || encoding === 'utf8') {
            encoding = null;
        }

        let textEncoder: TextEncoder = null;
        if (encoding) {
            // encoding other than utf-8 require non-standard polyfill
            textEncoder = new TextEncoder(encoding, {
                NONSTANDARD_allowLegacyEncoding: true
            });
        }

        let isContentArrayType = content instanceof Array;
        let blobParts: any[];
        if (isContentArrayType) {
            blobParts = content.slice(0);
        } else if (content != null && content !== '') {
            let body = textEncoder ? textEncoder.encode(content.toString()) : content;
            blobParts = [body];
        } else {
            blobParts = [];
        }
        if (includeBom && !isContentArrayType && (!encoding || encoding.slice(0, 3) === 'utf')) {
            const BOM_STRING = '\ufeff';
            let bom = textEncoder ? textEncoder.encode(BOM_STRING) : BOM_STRING;
            blobParts.unshift(bom);
        }

        let blob = blobPropertyBag ? new Blob(blobParts, blobPropertyBag) : new Blob(blobParts);
        return saveAs(blob, filename, false);
    }

    static sortByLabel(left, right): number {
        if (!left) {
            return -1;
        } else if (!right) {
            return 1;
        }

        let leftLabel: string = left.label;
        let rightLabel: string = right.label;
        if (!leftLabel) {
            return -1;
        } else if (!rightLabel) {
            return 1;
        }

        leftLabel = leftLabel.toLocaleLowerCase();
        rightLabel = rightLabel.toLocaleLowerCase();
        return leftLabel.localeCompare(rightLabel);
    }

    static reverseCmpOrder(cmp: (left: any, right: any) => number):
            (left: any, right: any) => number {
        return function(left, right) {
            let result = cmp(left, right);
            return -result;
        };
    }

    static lookUpOptionLabelByValue(optionList: any[], value: any): any {
        let targetOption: any = '';
        try {
            targetOption = optionList.find(option => {
                return option.value === value;
            });
        } catch (e) {
            console.log(e);
        }
        return targetOption && targetOption.label;
    }

    static lookUpSubTierOfActivityOptionLabelByValue(tierOfActivity, subTierOfActivity): any {
        const optionList = GlobalFunction.list_sub_tier_of_activitys[tierOfActivity];
        if (!optionList || !optionList.length) {
            return '';
        }
        return GlobalFunction.lookUpOptionLabelByValue(optionList, subTierOfActivity);
    }
}

setInterval(function () {
    GlobalFunction.TIMESTAMPNOW += 1000;
}, 1000);



// WEBPACK FOOTER //
// ./src/app/common/core/global_function.ts